// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `list-page .inline-input {
  display: inline-block;
  margin-bottom: -5px;
  margin-top: -7px;
  width: 100%;
}
list-page .panel-group .panel {
  border-radius: 0px;
}
list-page .panel-heading {
  background: #f3f3f4 !important;
}
list-page .panel-heading .panel-title a {
  width: 100%;
  display: block;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
}
list-page .panel-heading .smart-search-input {
  width: 50%;
  display: inline-block;
}
list-page .panel-body .form-group {
  margin-bottom: 0px;
}
list-page .panel-body .form-group label {
  font-size: 13px;
  margin-bottom: 10px;
}
list-page .btn.btn-primary {
  margin-bottom: 20px;
}
list-page table.dataTable.no-footer {
  border-bottom: 1px solid #ddd;
}
list-page table.dataTable.no-footer thead {
  background-color: #f4f8fb;
  color: #1a90dc;
  font-weight: 700;
}
list-page table.dataTable.no-footer thead th {
  text-align: left !important;
  border-bottom: none !important;
  font-size: 13px;
}
list-page table.dataTable.no-footer tbody tr td {
  padding-bottom: 9px;
  padding-top: 9px;
  font-size: 13px;
}
list-page table.dataTable.no-footer tbody tr td .label {
  font-size: 10px;
  width: 80px;
  display: inline-block;
  margin: 0;
  padding-top: 0px;
  padding-bottom: 0px;
  line-height: 18px;
}
list-page table.dataTable.no-footer tbody td.actions-col {
  padding-top: 5px;
  padding-bottom: 5px;
}
list-page table.dataTable.no-footer tbody td.actions-col a.btn {
  padding: 2px 8px 2px 8px;
}
list-page table.dataTable.no-footer tbody td.actions-col a.btn .fa {
  font-size: 13px;
}
list-page .dataTables_length {
  margin-top: 5px;
}
list-page .dataTables_processing {
  margin-top: 37px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/styles/listPage.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["list-page .inline-input {\n  display: inline-block;\n  margin-bottom: -5px;\n  margin-top: -7px;\n  width: 100%;\n}\nlist-page .panel-group .panel {\n  border-radius: 0px;\n}\nlist-page .panel-heading {\n  background: #f3f3f4 !important;\n}\nlist-page .panel-heading .panel-title a {\n  width: 100%;\n  display: block;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 600;\n}\nlist-page .panel-heading .smart-search-input {\n  width: 50%;\n  display: inline-block;\n}\nlist-page .panel-body .form-group {\n  margin-bottom: 0px;\n}\nlist-page .panel-body .form-group label {\n  font-size: 13px;\n  margin-bottom: 10px;\n}\nlist-page .btn.btn-primary {\n  margin-bottom: 20px;\n}\nlist-page table.dataTable.no-footer {\n  border-bottom: 1px solid #ddd;\n}\nlist-page table.dataTable.no-footer thead {\n  background-color: #f4f8fb;\n  color: #1a90dc;\n  font-weight: 700;\n}\nlist-page table.dataTable.no-footer thead th {\n  text-align: left !important;\n  border-bottom: none !important;\n  font-size: 13px;\n}\nlist-page table.dataTable.no-footer tbody tr td {\n  padding-bottom: 9px;\n  padding-top: 9px;\n  font-size: 13px;\n}\nlist-page table.dataTable.no-footer tbody tr td .label {\n  font-size: 10px;\n  width: 80px;\n  display: inline-block;\n  margin: 0;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  line-height: 18px;\n}\nlist-page table.dataTable.no-footer tbody td.actions-col {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\nlist-page table.dataTable.no-footer tbody td.actions-col a.btn {\n  padding: 2px 8px 2px 8px;\n}\nlist-page table.dataTable.no-footer tbody td.actions-col a.btn .fa {\n  font-size: 13px;\n}\nlist-page .dataTables_length {\n  margin-top: 5px;\n}\nlist-page .dataTables_processing {\n  margin-top: 37px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
